async function getExistingVenues() {
    const formData = new FormData();

    formData.append("userId", window.currentUserId);

    const res = await fetch("/get-existing-locations", {
        method: "POST",
        body: formData,
    });

    const data = await res.json();
    return data.data; // existing venues
}

export default getExistingVenues;
